<template>
  <main class="flex flex-1 flex-col">
    <slot />
  </main>
</template>
